/**
 * Central Lucide icon resolution for navigation (also see LanguageSelect.vue).
 */
import type { FunctionalComponent } from 'vue';
import type { Component } from 'vue';
import * as LucideIcons from 'lucide-vue-next';
import {
  CircleCheckBig,
  Home,
  Info,
  Building2,
  FileCheck,
  BookOpen,
  Megaphone,
  GraduationCap,
  Briefcase,
  Users,
} from 'lucide-vue-next';

const L = LucideIcons as Record<string, FunctionalComponent>;

export const BuildingNavIcon = L.Building ?? Building2;
export const MessageSquareNavIcon = L.MessageSquare ?? Info;
export const FileTextNavIcon = L.FileText ?? L.FileTextIcon ?? FileCheck;
export const SearchNavIcon = L.Search;
export const UserNavIcon = L.User;

export const MENU_ICON_MAP: Record<string, Component> = {
  'circle-check-big': CircleCheckBig,
  info: Info,
  home: Home,
  building: BuildingNavIcon,
  'building-2': Building2,
  'file-check': FileCheck,
  'file-text': FileTextNavIcon,
  'book-open': BookOpen,
  'message-square': MessageSquareNavIcon,
  megaphone: Megaphone,
  'graduation-cap': GraduationCap,
  briefcase: Briefcase,
  users: Users,
};

export function resolveMenuIcon(iconKey: string | undefined): Component {
  return MENU_ICON_MAP[iconKey ?? 'info'] ?? Info;
}
